const sizeAgreement = {
    'x-small': 'xs',
    'small': 's',
    'medium': 'm',
    'large': 'l',
    'x-large': 'xl',
    'xx-large': 'xxl',
};

function updateAvailableSizesModal(clicked_color) {
    var clicked_color_value = clicked_color.closest('.product-modal__swatch-color-border')
                                                .attr('data-variant-value');
    try {
        var color_name_and_size_unavailable = $('#product-modal__select-hidden')
            .find("option[data-variant-title^='"+clicked_color_value+"']")
            .filter("[data-available='false']");
        var unavailable_sizes = [];
        color_name_and_size_unavailable.each(function() {
            var variant_title = $(this).data('variant-title');
            var size = variant_title.replace(clicked_color_value + '-', '');
            if (sizeAgreement[size]) {
                unavailable_sizes.push(sizeAgreement[size]);
            }
        });

        
        $('.product-modal__swatch-container-each--other button').removeClass('unavailable');
        unavailable_sizes = unavailable_sizes.map(function(x){ return x.toUpperCase().trim(); })
        $('.product-modal__swatch-container-each--other button').each(function(){
            if (unavailable_sizes.includes($(this).text().toUpperCase().trim())) {
                $(this).addClass('unavailable');
            }
        });
    } catch (e) {
        console.log(e);
    }
}

function parametrize(color_name) {
    return color_name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
}

function getFirstColorName(results) {
    for (let option of results.options) {
        let colorName = parametrize(option.values[0]);
        if (!results.tags.includes(`hide-${colorName}`) && !results.tags.includes(`hide-manual-${colorName}`)) {
            return colorName;
        }
    }
    return null;
}

function cardModalWindow() {
    if ($("body").hasClass("template-collection") ||
        $("body").hasClass("template-product") ||
        $("body").hasClass("template-search") ||
        $("body").hasClass("template-index") ||
        $("body").is("#z-supply-spring-2021-collection") ||
        $("body").is("#checkout-page") ||
        $("body").hasClass("page_layout--essentials-2022") ||
        $("body").hasClass("template-404") ||
        $("body").is("#marketplace-by-z-supply")) {
        // Trigger Quick View
        $("body").on("click", ".product-card__quick-view-trigger, .product-card__quick-view-trigger_only", function () {
            let clickedColorName = $(this).closest('.product-card').find('.product-card__swatch-container .product-card__swatch-border.active').attr('data-swatch-name');
            $(".product-modal__container").addClass("active");
            if ( $(this).attr("data-free-gift-modal") ) {
                // This is mean product in modal window is free gift
                $(".product-modal__container").addClass("free-gift-modal");
            } else {
                $(".product-modal__container").removeClass("free-gift-modal");
            }
            // Set focus on quickshop modal
            slate.a11y.trapFocus({
                $container: $('#quickshop-modal'),
                namespace: 'quickshop_focus'
            });

            var $productHandle = $(this).attr("data-product-handle");
            var productId = $(this).attr("attr-pr-id");
            $.ajax({
                type: 'GET',
                url: "/products/" + $productHandle + ".js",
                dataType: 'json',
                success: function (results) {
                    $("body").css("overflow", "hidden")
                    // Printing out Modal
                    var $description_full = results.description
                    var $description = results.description.split("<!-- details -->")[0];
                    var $price = results.price / 100;
                    $(".product-modal__content").append(
                        '<div class="product-modal__content-image">' +
                        '</div>' +
                        '<div class="product-modal__content-info">' +
                        '<h1 class="product-modal__content-title">' + results.title + '</h1>' +
                        '<input type="hidden" class="ptitle" value="' + results.title + '">' +
                        '<input type="hidden" class="pid" value="' + results.id + '">' +
                        '<input type="hidden" class="ptype" value="' + results.type + '">' +
                        '<input type="hidden" class="pbrand" value="' + results.vendor + '">' +
                        '<input type="hidden" class="pprice" value="' + $price + '">' +
                        '<p class="product-modal__content-price">$' + $price + '</p>' +
                        '<p class="product-modal__content-description">' + $description + '</p>' +
                        '<div class="product-modal__swatch-container"></div>' +
                        '<div class="product-modal__input-atc">' +
                        '<div class="product-modal__input-container">' +
                        '<label class="product-modal__input-label" for="product-quantity">Quantity</label>' +
                        '<button class="product-modal__input-adjust product-modal__input-adjust--minus" aria-label="Decrease item quantity by one">-</button>' +
                        '<input class="product-modal__input" value="1" type="text" id="product-quantity">' +
                        '<button class="product-modal__input-adjust product-modal__input-adjust--plus" aria-label="Increase item quantity by one">+</button>' +
                        '</div>' +
                        '<button class="product-modal__add-to-cart btn">ADD TO BAG</button>' +
                        '</div>' +
                        '<select id="product-modal__select-hidden"></select>' +
                        '<a class="product-modal__product-url" href="' + results.url + '">VIEW FULL DETAILS</a>' +
                        '</div>'
                    )

                    // Printing Out Swatches
                    $.each(results.options, function (i, option) {
                        var handleizedOption = parametrize(option.name)
                        // Color Swatch
                        if (option.name === 'Color') {
                            // Append Swatch Title (Color)
                            $(".product-modal__swatch-container").append(
                                '<div class="product-modal__swatch-container-each--color product-modal__swatch-container-each" role="group" aria-labelledby="product-modal-swatch-header-' + handleizedOption + '">' +
                                '<p class="product-modal__swatch-header product-modal__swatch-header--color" id="product-modal-swatch-header-' + handleizedOption + '">' + option.name + '</p>' +
                                '</div>'
                            )
                            // Append Swatch Items (Eg. red)
                            
                            var firstColorName = getFirstColorName(results);
                            $.each(option.values, function (i, value) {
                                var firstLoop = ""
                                var handleizedValue = value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                                var colorValue = value
                                const normalizeColorName = colorName => colorName.replaceAll(" ", "-").toLowerCase();
                                let activeColor = clickedColorName ? normalizeColorName(clickedColorName) : firstColorName;
                                firstLoop = handleizedValue === activeColor ? "active" : "";
                                
                                var addSwatch = true;
                                if (results.tags.length > 0) {
                                    console.log(results.tags)
                                    $.each(results.tags, function (i, tag) {
                                        if (tag.indexOf("hide-") > -1) {
                                            var prefix = "hide-";
                                            if (tag.indexOf("hide-manual-") > -1) {
                                                prefix = "hide-manual-";
                                            }
                                            newTag = tag.replace(prefix, "").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '');
                                            if (handleizedValue == newTag) {
                                                addSwatch = false;
                                            }
                                        }
                                    })
                                    if (addSwatch == true) {
                                        var relevantCard = $('div#' +  results.id );
                                        var relevantCardColorSwatch =  relevantCard.find('.product-card__text-container').find('.product-card__swatch-container').find('button[data-swatch-name="'+colorValue+'"]');
                                        var modalWindowColorSwatch;
                                        if (relevantCardColorSwatch.length > 0) {
                                            var backgroundImageCss = relevantCardColorSwatch.find('.product-card__swatch').css('background-image');
                                            if (backgroundImageCss) {
                                                modalWindowColorSwatch = backgroundImageCss.replace(/^url\(["']?/, '').replace(/["']?\)$/, '');
                                            } else {
                                                // Fallback or default image if css property is not found
                                                modalWindowColorSwatch = 'https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + handleizedValue + '.png';
                                            }
                                        } else {
                                            modalWindowColorSwatch = 'https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + handleizedValue + '.png';
                                        }
                                        $(".product-modal__swatch-container-each--color").append(
                                            '<div js-modal-variant data-variant-value=' + handleizedValue + ' class="product-modal__swatch-color-border ' + firstLoop + '">' +
                                            '<div class="modal_window-color-label">'+value+'</div>' +
                                            '<button class="product-modal__swatch-color" style="background-color:' + value + '; background-image: url('+modalWindowColorSwatch+')" aria-label="' + value + '"></button>' +
                                            '</div>'
                                        );
                                    }

                                } else {
                                    $(".product-modal__swatch-container-each--color").append(
                                        '<div js-modal-variant data-variant-value=' + handleizedValue + ' class="product-modal__swatch-color-border ' + firstLoop + '">' +
                                        '<button class="product-modal__swatch-color" style="background-color:' + value + '; background-image: url(https://cdn.shopify.com/s/files/1/0076/7075/9477/files/color-' + handleizedValue + '.png" aria-label="' + value + '"></button>' +
                                        '</div>'
                                    )
                                }
                            });
                        }
                        // Swatch that are not Color
                        else {
                            $(".product-modal__swatch-container").append(
                                '<div class="product-modal__swatch-container-each--other product-modal__swatch-container-each" role="group" aria-labelledby="product-modal-swatch-header-' + handleizedOption + '">' +
                                '<p class="product-modal__swatch-header product-modal__swatch-header--other" id="product-modal-swatch-header-' + handleizedOption + '">' + option.name + '</p>' +
                                '</div>'
                            )
                            $.each(option.values, function (i, value) {
                                var firstLoop = ""
                                if (i == 0) {
                                    firstLoop = "active"
                                }
                                var currentHandleizedValue = value.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                                var currentValue = value;
                                if (currentHandleizedValue == 'x-small') {
                                    currentValue = 'XS'
                                } else if (currentHandleizedValue == 'small') {
                                    currentValue = 'S'
                                } else if (currentHandleizedValue == 'medium') {
                                    currentValue = 'M'
                                } else if (currentHandleizedValue == 'large') {
                                    currentValue = 'L'
                                } else if (currentHandleizedValue == 'x-large') {
                                    currentValue = 'XL'
                                } else if (currentHandleizedValue == 'xsmall-small') {
                                    currentValue = 'XS/S'
                                } else if (currentHandleizedValue == 'small-medium') {
                                    currentValue = 'S/M'
                                } else if (currentHandleizedValue == 'medium-large') {
                                    currentValue = 'M/L'
                                } else if (currentHandleizedValue == 'large-xlarge') {
                                    currentValue = 'L/XL'
                                } else if (currentHandleizedValue == 'one-size') {
                                    currentValue = 'OS'
                                } else if (currentHandleizedValue.indexOf("size-") != -1) {
                                    currentValue = currentHandleizedValue.replace("size-", "")
                                } else if (currentHandleizedValue.indexOf("-months") != -1) {
                                    currentValue = currentHandleizedValue.replace("-months", "")
                                }
                                $(".product-modal__swatch-container-each--other").append(
                                    '<button js-modal-variant data-variant-value="' + value + '" class="product-modal__swatch-other ' + firstLoop + '" aria-label="' + value + '">' + currentValue + '</button>'
                                )
                            })
                        }
                    })

                    // Printing out Variant ID into a hidden select
                    $.each(results.variants, function (i, variant) {
                        $handleizedVariantTitle = variant.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                        if (variant.featured_image != null) {
                            var variantImageSrc = variant.featured_image.src;
                        }
                        $("#product-modal__select-hidden").append(
                            '<option data-available=' + variant.available + ' data-variant-image=' + variantImageSrc + ' data-variant-price=' + variant.price + ' data-variant-title=' + $handleizedVariantTitle + ' data-variant-id="' + variant.id + '">' + $handleizedVariantTitle + '</option>')
                    })
                    // Printing Out images
                    var $selection = "";
                    $(".active[js-modal-variant]").each(function (index) {
                        var $value = $(this).attr("data-variant-value").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                        if (index !== 0) {
                            $selection = $selection + "-" + $value;
                        } else {
                            $selection = $selection + $value;
                        }
                    })
                    var $selectVariantImage = $("#product-modal__select-hidden option[data-variant-title='" + $selection + "']").attr("data-variant-image");
                    if (typeof $selectVariantImage !== "undefined" && $selectVariantImage !== null) {
                        var lazyloadImage = $selectVariantImage.replace(".jpg", '_{width}x.jpg')
                        var variantImage = '<img class="lazyload" src="' + $selectVariantImage.replace('.jpg', '_300x.jpg') + '" data-src="' + lazyloadImage + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto"></img>'
                        $(".product-modal__content-image").append(
                            variantImage
                        )
                    } else {
                        $(".product-modal__content-image").append(
                            '<img src="' + results.featured_image + '"/>'
                        )
                    }
                    // Detect if on load if product is available
                    var $selection = "";
                    $(".active[js-modal-variant]").each(function (index) {
                        var $value = $(this).attr("data-variant-value").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                        if (index !== 0) {
                            $selection = $selection + "-" + $value;
                        } else {
                            $selection = $selection + $value;
                        }
                    })
                    var $selectVariantAvailable = $("#product-modal__select-hidden option[data-variant-title='" + $selection + "']").attr("data-available");
                    if ($selectVariantAvailable == "false") {
                        $(".product-modal__add-to-cart").prop("disabled", true).text("Sold Out");
                    } else {
                        $(".product-modal__add-to-cart").prop("disabled", false).text("ADD TO BAG");
                    }




                    // Clicking on Modal Swatch
                    $("[js-modal-variant]").click(function () {
                        var $parent = $(this).closest(".product-modal__swatch-container-each");
                        var $children = $parent.children(".active[js-modal-variant]")
                        $children.removeClass("active");
                        $(this).addClass("active");
                        // Changing Price on swatch click
                        var $selection = "";
                        $(".active[js-modal-variant]").each(function (index) {
                            var $value = $(this).attr("data-variant-value").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                            if (index !== 0) {
                                $selection = $selection + "-" + $value;
                            } else {
                                $selection = $selection + $value;
                            }
                        })
                        var $selectVariantPrice = $("#product-modal__select-hidden option[data-variant-title='" + $selection + "']").attr("data-variant-price");
                        $(".product-modal__content-price").html("$" + $selectVariantPrice / 100)

                        var $selectVariantAvailable = $("#product-modal__select-hidden option[data-variant-title='" + $selection + "']").attr("data-available");
                        if ($selectVariantAvailable == "false") {
                            $(".product-modal__add-to-cart").prop("disabled", true).text("Sold Out")
                        } else {
                            $(".product-modal__add-to-cart").prop("disabled", false).text("ADD TO BAG");
                        }
                        $(".product-modal__content-image").empty();
                        var $selectVariantImage = $("#product-modal__select-hidden option[data-variant-title='" + $selection + "']").attr("data-variant-image");
                        if (typeof $selectVariantImage !== "undefined" && $selectVariantImage !== null) {
                            var lazyloadImage = $selectVariantImage.replace(".jpg", '_{width}x.jpg')
                            var variantImage = '<img class="lazyload" src="' + $selectVariantImage.replace('.jpg', '_300x.jpg') + '" data-src="' + lazyloadImage + '" data-widths="[180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" data-sizes="auto"></img>'


                            $(".product-modal__content-image").append(
                                variantImage
                            )
                        } else {
                            $(".product-modal__content-image").append(
                                '<img src="' + results.featured_image + '"/>'
                            )
                        }
                    })
                    // Clicking on Add to Cart Button
                    $(".product-modal__add-to-cart").click(function () {
                        var $selection = "";
                        $(".active[js-modal-variant]").each(function (index) {
                            var $value = $(this).attr("data-variant-value").toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/-$/, '').replace(/^-/, '')
                            if (index !== 0) {
                                $selection = $selection + "-" + $value;
                            } else {
                                $selection = $selection + $value;
                            }
                        })
                        var $selectVariantId = $("#product-modal__select-hidden option[data-variant-title='" + $selection + "']").attr("data-variant-id");
                        var $inputQuantity = $(".product-modal__input").val();
                        var productForm = $('.product-modal__content-info');
                        window.dataLayer.push({
                            event: 'ee_addToCart',
                            name: productForm.find('.ptitle').val(),
                            id: productForm.find('.pid').val(),
                            price: productForm.find('.pprice').val(),
                            brand: productForm.find('.pbrand').val(),
                            product_type: productForm.find('.ptype').val(),
                            quantity: $inputQuantity,
                            variant: $selectVariantId,
                            g_product_id: "shopify_US_" + productForm.find('.pid').val() + "_" + $selectVariantId
                        });
                        $.ajax({
                            type: 'POST',
                            url: '/cart/add.js',
                            dataType: 'json',
                            data: 'quantity=' + $inputQuantity + '&id=' + $selectVariantId,
                            id: $selectVariantId,
                            quantity: $inputQuantity,
                            error: function () {
                                console.log("error")
                            },
                            success: function (response) {
                                try {
                                    OrderSummaryUpdater.prototype.refresh();
                                } catch (e) {
                                    console.log(e);
                                }
                                // Remove focus on quickshop modal
                                slate.a11y.removeTrapFocus({
                                    $container: $('#quickshop-modal'),
                                    namespace: 'quickshop_focus'
                                });

                                $(".product-modal__container").removeClass("active");
                                $(".product-modal__content").empty();
                                $("body").css("overflow", "visible")
                                ajaxCart.load();
                                klavioAddedToCartViaAjax(response);
                            }
                        })
                    })

                    // Minus Button adjust quantity
                    $(".product-modal__input-adjust--minus").click(function () {
                        var $inputVal = parseInt($(".product-modal__input").val());
                        if (($inputVal - 1) > 0) {
                            $(".product-modal__input").val($inputVal - 1)
                        }
                    })
                    // Plus Button adjust quantity
                    $(".product-modal__input-adjust--plus").click(function () {
                        var $inputVal = parseInt($(".product-modal__input").val());
                        $(".product-modal__input").val($inputVal + 1)
                    })
                    // Get review info from Yotpo
                    $.get("https://api.yotpo.com/v1/widget/enAOaNpJKUtBdeMh0FV2HDijFDYB2wkWZW9hbG5z/products/" + productId + "/reviews.json", function (data) {
                        if (data.status.code == 200) {
                            $("<div class='modal-window__yotPo-review'><div class='stars'></div><div class='link'></div></div>").insertAfter(".product-modal__content-price");
                            let summary = data.response.bottomline
                            let fullStar = '<img class="star" src="https://cdn.shopify.com/s/files/1/0076/7075/9477/files/black-star.svg">'
                            let emptyStar = '<img class="star" src="https://cdn.shopify.com/s/files/1/0076/7075/9477/files/gray-empty-star.svg">'

                            if (summary.total_review > 0) {
                                for (var i = 0; i < 5; i++) {
                                    if (summary.average_score > i) {
                                        $(".modal-window__yotPo-review .stars").append(fullStar);
                                    } else {
                                        $(".modal-window__yotPo-review .stars").append(emptyStar);
                                    }
                                }
                            }
                            // Add link to product
                            if (summary.total_review == 1) {
                                $("<a class='link' href='/products/" + $productHandle + "'>" + summary.total_review + " Review</a>").insertAfter(".modal-window__yotPo-review .stars");
                            } else if (summary.total_review > 1) {
                                $("<a class='link' href='/products/" + $productHandle + "'>" + summary.total_review + " Reviews</a>").insertAfter(".modal-window__yotPo-review .stars");
                            }
                        }
                    });
                    if ($('.product-modal__container').hasClass('free-gift-modal')) {
                        // Code to execute when the element has the class
                        // Append '.product-description-text_modal' before first '.product-description-text' element
                        $('.free-gift-modal').find('.product-description-text').first().before('<div class="product-description-text product-description-text_modal"></div>');
                        $('.free-gift-modal').find('.product-description-text').addClass('d-none');
                        $('.free-gift-modal').find('.product-description-text_modal').removeClass('d-none').addClass('d-block');
                        
                        // Append '<p>Select a size and color for your free gift</p>' into '.product-description-text_modal'
                        $('.free-gift-modal').find('.product-description-text_modal').append('<p>Select a size and color for your free gift</p>');

                        // Parse 'fit' from description
                        var $fit = $description_full.match(/<p><strong><span style="text-decoration: underline;" data-mce-style="text-decoration: underline;">FIT<\/span><\/strong><\/p>\n<p>(.*?)<\/p>/);
                        if ($fit) {
                            $('.free-gift-modal').find('.product-modal__swatch-container-each--other').append('<div class="d-block w-100"><p>' + $fit[1] + '</p></div>');
                        }
                    }

                    $(".product-modal__swatch-color-border button").on("click", function () {
                        updateAvailableSizesModal($(this));
                    });
                }
            });

            clickedQuickShop();
        });

        // Click close to close modal
        $(".product-modal__close").click(function () {
            // Remove focus on quickshop modal
            slate.a11y.removeTrapFocus({
                $container: $('#quickshop-modal'),
                namespace: 'quickshop_focus'
            });

            $(".product-modal__container").removeClass("active");
            $(".product-modal__content").empty();
            $("body").css("overflow", "visible")
        })

        // Click anywhere but the modal and trigger close modal
        $(".product-modal__container").click(function () {
            // Remove focus on quickshop modal
            slate.a11y.removeTrapFocus({
                $container: $('#quickshop-modal'),
                namespace: 'quickshop_focus'
            });

            $(this).removeClass("active");
            $(".product-modal__content").empty();
            $("body").css("overflow", "visible")
        });
        $(".product-modal__content").click(function (e) {
            e.stopPropagation();
        });

        // Escape Close Modal
        $(document).on('keyup', function (evt) {
            if (evt.keyCode == 27) {
                // Remove focus on quickshop modal
                slate.a11y.removeTrapFocus({
                    $container: $('#quickshop-modal'),
                    namespace: 'quickshop_focus'
                });

                $(".product-modal__container").removeClass("active");
                $(".product-modal__content").empty();
                $("body").css("overflow", "visible")
            }
        });

        // No modal on mobile
        // enquire.register(theme.config.mediaQueries.smallDown, {
        //     match: function () {
        //         $(".product-modal__close").trigger("click");
        //     },
        //     unmatch: function () {}
        // })
    }
    // Image change for Home Page
    $(".homepage-featured-products__content .color__border, #wrap_slider_spring_2021_page .color__border").click(function () {
        console.log("test");
        var $currentVal = $(this).attr("data-val");
        var $swatch = $(this).closest(".swatch")
        var $link = $swatch.closest(".product-card").find(".product-card__image-container").children(".product-card__link");
        $link.find(".product-card__image.active").removeClass("active");
        $link.children(".product-card__image").each(function () {
            if ($(this).attr("data-title").indexOf($currentVal) > -1) {
                $(this).addClass("active");
                return false
            }
        })
    });
}

// Only currently allowing to run on collection / product page
window.addEventListener("load", function () {
    cardModalWindow();
});